import AvenirNextRoundedProBold from 'assets/fonts/AvenirNextRoundedProBold.otf'
import AvenirNextRoundedProBoldIt from 'assets/fonts/AvenirNextRoundedProBoldIt.otf'
import AvenirNextRoundedProDemi from 'assets/fonts/AvenirNextRoundedProDemi.otf'
import AvenirNextRoundedProDemiIt from 'assets/fonts/AvenirNextRoundedProDemiIt.otf'
import AvenirNextRoundedProItalic from 'assets/fonts/AvenirNextRoundedProItalic.otf'
import AvenirNextRoundedProMed from 'assets/fonts/AvenirNextRoundedProMed.otf'
import AvenirNextRoundedProMedIt from 'assets/fonts/AvenirNextRoundedProMedIt.otf'
import AvenirNextRoundedProReg from 'assets/fonts/AvenirNextRoundedProReg.otf'


export const Colors = {
    baseTextColor: "#686868",
    grayTextColorDark: "#AFAFAF",
    grayTextColorDarkest: "#959595",
    grayTextColorDarkestDark: "#6F6F6F",
    grayTextColor: "#C4C4C4",
    grayTextColor2: "#C6C6C6",
    successTextColor: "#4CAF50",
    errorTextColor: "#EF5350",
    infoTextColor: "#1565C0",
    whiteColor: "#FFFFFF",
    itemBackgroundColor: "#F3F3F3",
    grayBackground: "#FAFAFA",
    orangePrimary: "#ff8800",
    disabled: "#dddddd"
} 

export const Fonts = {
    fontStyleRegular: AvenirNextRoundedProReg,
    fontStyleMedium: AvenirNextRoundedProMed,
    fontStyleBold: AvenirNextRoundedProBold,
    fontStyleDemi: AvenirNextRoundedProDemi,
    fontStyleItalic: AvenirNextRoundedProItalic,
    fontStyleMediumIt: AvenirNextRoundedProMedIt,
    fontStyleBoldIt: AvenirNextRoundedProBoldIt,
    fontStyleDemiIt: AvenirNextRoundedProDemiIt,
}

export const BaseURLs = {
    debug: {
        //url: "http://192.168.15.9:50249/api/"
        //url: "https://192.168.15.9:44311/api/"
        url: "https://ellodelivery-api.herokuapp.com/api/"
        //url: "http://localhost:8080/api"
    },
    prod: {
        url: "https://ellodelivery-api.herokuapp.com/api/"
    }
}